import { setValToStorages, getValFromStorages } from "../../lib/cookies";
import EventBus from "../../EventBus";
import { SettingsResource } from "@/services";

const state = {
  loading: false,
  isMobile: null,
  rating: null,
  isApropriateAge: null,
  baseAssetsPath: "/app-static/uploads/",
  origin: "https://dayz.com/"
};

const getters = {
  isMobile: state => state.isMobile,
  origin: state => state.origin,
  isApropriateAge: state => state.isApropriateAge,
  baseAssetsPath: state => state.baseAssetsPath,
  loading: state => state.loading,
  rating: state => state.rating
};

const actions = {
  getAge({ state, commit }) {
    if (state.isApropriateAge === null) {
      const cachedValue = getValFromStorages("verified_age");
      if (cachedValue !== undefined) {
        const bool = cachedValue === "1";
        commit("setAge", bool);
        return bool;
      }
    }

    return state.isApropriateAge;
  },
  getSettings({ state, commit }) {
    return SettingsResource.get().then(response => {
      commit("setRating", response.data.rating);
    });
  },
  setAge({ commit }, age) {
    // we're storing values inside locastorage/cookies as 1 or 0 value
    const result = age ? 1 : 0;
    commit("setAge", result);
    setValToStorages("verified_age", result, 30);
  },
  setLoading({ commit }, result) {
    // for nice page transition
    // scroll to top only after page changed and load
    if (!result) {
      EventBus.$emit("dataLoaded");
    }
    commit("setLoading", result);
  }
};

const mutations = {
  isMobile(state, val) {
    state.isMobile = val;
  },
  setAge(state, val) {
    state.isApropriateAge = val;
  },
  setLoading(state, val) {
    if (state.loading !== val) {
      state.loading = val;
    }
  },
  setRating(state, val) {
    if (state.rating !== val) {
      state.rating = val;
    }
  },
  setOrigin(state, url) {
    if (state.origin !== url) {
      state.origin = url;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
